import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "@/app/router";
import { site } from "@/config/site";
import "@/styles/global.css";

if (site.plausibleDomain) {
  const script = document.createElement("script");
  script.defer = true;
  script.dataset.domain = site.plausibleDomain;
  script.src = "https://plausible.io/js/script.js";
  document.head.appendChild(script);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
